var React = require('react');

function Person (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8,8c2.2,0,4-1.8,4-4s-1.8-4-4-4S4,1.8,4,4S5.8,8,8,8z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M8,9.3l-6.7,3.3V16h13.3v-3.3L8,9.3z","fill":"currentColor","key":1})]);
}

Person.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Person;

Person.default = Person;
